var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var FootprintMetaData = require("./footprintMetaData.js");
var EllipseData = require("../svg/ellipseData.js");
var SolderMaskData = require("../footprint/solderMaskData.js");
var LayeredShapeData = require("../footprint/layeredShapeData.js");

var FootPrintData = function (newMetaData) {
    var self = this;

    this.makeObservableTreeNode();

    this.metaData = this.value("metaData", true);

    // Pads collection must contain PadData
    this.pads = this.set("pads", true);
    // silkscreen all have to be layered shape data.
    this.silkscreen = this.list("silkscreen", true);
    // assembly shapes are not layered shape data (exports directly to tDocu)
    this.assembly = this.list("assembly", true); 
    // holes are not layered shapes
    this.holes = this.set("holes", true);
    // replicators are not exported.  They are parametric instances of other data.
    this.replicators = this.set("replicators", true);
    // everything else below here are layered shapes
    this.solderMask = this.set("solderMask", true);
    this.solderPaste = this.set("solderPaste", true);
    this.copperRestricts = this.set("copperRestricts", true);
    this.componentRestricts = this.set("componentRestricts", true);
    // via Resrtics are layered shapes, but are always 'allLayers' (exported to via layer)
    this.viaRestricts = this.set("viaRestricts", true);
    this.glue = this.set("glue", true);
    // documentation all must be layered shape datas.
    // (exported to tDocu and bDocu)
    this.documentation = this.list("documentation", true);
    
    // these are collections that will be exported into eagles propNames
    // and propValues layer.  Both are layered shape datas.
    this.propNames = this.list("propNames", true);
    this.propValues = this.list("propValues", true);

    this.boardThickness = 1600;//1600;  // extrusion amount
    this.copperThickness = 34;  // extrusion amount
    this.silkscreenThickness = 40;  // extrusion amount
    this.curvePrecision3d = 15; // precision for curve (higher is less)
    this.segmentPrecision3d = 3; // segments per half circle, traces and silkscreen lines

    this.padNames = new lib_core.NameManager();    // TODO: current namelist should become a shadow, which can be used by the validators and proposal get
    var uniquePadNameValidator = function(name){
        return name != undefined && !self.padNames.isRegistered('', name);
    };
    this.pads.onAdd("nameManager", function(pad){
        if (self.isAlive() && self.padNames.isRegistered('', pad.name())) pad.name(self.padNames.getProposal('', pad.name())); // if name of added pad already exist propose a new unique name
        self.padNames.register('', pad.name());
        pad.name.onChange("nameManager", function(name, old){
            self.padNames.remove('', old);
            self.padNames.register('', name);
        });
        pad.name.validator = uniquePadNameValidator;
    });
    this.pads.onRemove("nameManager", function(pad){
        self.padNames.remove('', pad.name());
        pad.name.removeHandlers("nameManager");
        pad.name.validator = null;
    });
    var uniquePadNameListValidator = function(idx, name){
        return name != undefined && !self.padNames.isRegistered('', name);
    };
    this.replicators.onAdd("nameManager", function(replicator){
        replicator.nameList.forEach(function (idx, name) {
            if (self.isAlive() && self.padNames.isRegistered('', name)){  // if name of added pad already exist propose a new unique name
                name = self.padNames.getProposal('', name);
                replicator.nameList.put(idx, name);
            }
            self.padNames.register('', name);
        });
        replicator.nameList.onBubble("nameManager", function(event){
            if (event.oldValue != undefined) self.padNames.remove('', event.oldValue);
            if (event.value != undefined) self.padNames.register('', event.value);
        });
        replicator.nameList.validator = uniquePadNameListValidator;
    });
    this.replicators.onRemove("nameManager", function(replicator){
        replicator.nameList.forEach(function (idx, name) {
            self.padNames.remove('', name);
        });
        replicator.nameList.removeHandlers("nameManager");
        replicator.nameList.validator = null;
    });

    this.isComplete = this.shadow("isComplete",
        function() {
            // return self.pads.size() !== 0
            //     || self.silkscreen.size() !== 0
            //     || self.holes.size() !== 0
            //     || self.replicators.size() !== 0;
            return true;
            // we need to be able to save empty footprints because
            // some footprints only contain things we don't yet import
        }, null,
        [[this, this.onBubble]]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function(){
            var boundingBox = null;
            self.pads.forEach(function(pad) {
                var bb = pad.boundingBox && pad.boundingBox();
                if (bb) boundingBox = bb.merge(boundingBox);
            });
            self.silkscreen.forEach(function(index, element){
                var elementBB = element.boundingBox && element.boundingBox();
                if (elementBB) boundingBox = elementBB.merge(boundingBox);
            });
            self.assembly.forEach(function(index, element){
                var elementBB = element.boundingBox && element.boundingBox();
                if (elementBB) boundingBox = elementBB.merge(boundingBox);
            });
            self.holes.forEach(function(hole) {
                var bb = hole.boundingBox && hole.boundingBox();
                if (bb) boundingBox = bb.merge(boundingBox);
            });
            self.replicators.forEach(function(replicator) {
                var bb = replicator.boundingBox && replicator.boundingBox();
                if (bb) boundingBox = bb.merge(boundingBox);
            });
            this.solderMask.forEach(function(mask) {
                var bb = mask.boundingBox && mask.boundingBox();
                if (bb) boundingBox = bb.merge(boundingBox);
            });
            this.solderPaste.forEach(function(paste) {
                var bb = paste.boundingBox && paste.boundingBox();
                if (bb) boundingBox = bb.merge(boundingBox);
            });
            this.copperRestricts.forEach(function(copperRestric) {
                var bb = copperRestric.boundingBox && copperRestric.boundingBox();
                if (bb) boundingBox = bb.merge(boundingBox);
            });
            this.componentRestricts.forEach(function(componentRestrict) {
                var bb = componentRestrict.boundingBox && componentRestrict.boundingBox();
                if (bb) boundingBox = bb.merge(boundingBox);
            });
            this.viaRestricts.forEach(function(viaRestrict) {
                var bb = viaRestrict.boundingBox && viaRestrict.boundingBox();
                if (bb) boundingBox = bb.merge(boundingBox);
            });
            this.glue.forEach(function(oneGlue) {
                var bb = oneGlue.boundingBox && oneGlue.boundingBox();
                if (bb) boundingBox = bb.merge(boundingBox);
            });
            this.documentation.forEach(function(doc) {
                var bb = doc.boundingBox && doc.boundingBox();
                if (bb) boundingBox = bb.merge(boundingBox);
            });
            // default bounding box
            if(!boundingBox) boundingBox = new lib_geometry.BoundingBox(1, 1, 0, 0);
            
            return boundingBox;
        },
        [this.pads, this.silkscreen, this.assembly, this.holes, this.replicators,
        this.solderMask, this.solderPaste, this.copperRestricts, this.componentRestricts,
        this.viaRestricts, this.glue, this.documentation]
    );

    this.padsBoundingBox = this.cachedFunction("padsBoundingBox",
        function(){
            var boundingBox = null;
            self.pads.forEach(function(pad) {
                var bb = pad.boundingBox && pad.boundingBox();
                if (bb) boundingBox = bb.merge(boundingBox);
            });
            return boundingBox;
        },
        [this.pads]
    );



    if(newMetaData) {
        var metaData = new FootprintMetaData();
        metaData.name("New Footprint");
        metaData.summary("");
        metaData.description("");
        this.metaData(metaData);
    }
};
lib_core.mixin(FootPrintData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(FootPrintData, "FootprintData");

module.exports = FootPrintData;

FootPrintData.prototype.prepareDescription = function() {
    while(!this.replicators.isEmpty()){
        this.replicators.getOne().expand(true);
    }
};
